import { Spin, Icon } from 'antd';
import React, {Component} from "react";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export function Spinner(props){
  return(
    <Spin indicator={antIcon} />
  )
}



// WEBPACK FOOTER //
// ./src/public/components/UIToolbox.js